import { useDispatch } from 'react-redux'
import { trackInternalEvent } from '@rio/tracking'

import { useUser } from 'builder/hooks/useUser'
import { useFeaturesConfig } from 'builder/hooks/featureConfig/useFeaturesConfig'

import { actions } from 'builder/modules/panel'
import { actions as userActions } from 'builder/modules/user'

type ReturnType = {
  isBannerVisible: boolean
  isButtonVisible: boolean
  closeBanner: () => void
  handleBookCoachPromo: () => void
  handleBookCoachButton: () => void
}

export const useCoachBanner = (): ReturnType => {
  const user = useUser()
  const dispatch = useDispatch()
  const { features } = useFeaturesConfig()

  const isBannerVisible = !user?.uiStates?.coachingPromoSeen && !!features?.rbCoaching
  const isButtonVisible = !!(user?.uiStates?.coachingPromoSeen && features?.rbCoaching)

  const updateUIStates = () => {
    dispatch(actions.setUIStatesConfigStatus({ coaching_promo_seen: true }))
    dispatch(userActions.setUIUserState({ coachingPromoSeen: true }))
  }

  const closeBanner = () => {
    trackInternalEvent('click_coaching_promo', { button: 'next' })
    updateUIStates()
  }

  const handleBookCoachPromo = () => {
    trackInternalEvent('click_coaching_promo', { button: 'book_a_coach' })
    updateUIStates()
    window.open('/app/career-coaching', '_blank')
  }

  const handleBookCoachButton = () => {
    trackInternalEvent('click_book_a_coach', { label: 'builder' })
    window.open('/app/career-coaching', '_blank')
  }

  return {
    isBannerVisible,
    isButtonVisible,
    closeBanner,
    handleBookCoachPromo,
    handleBookCoachButton,
  }
}
